import { createSelector } from 'reselect';

import { getRedirectUrl } from './helpers';


const getUserManager = ({ portal }) => {
	return portal.userManager;
};

const getRedirectUrlSelector = ({ overview: { user }, portal: { environmentProperties } }) => {
	return getRedirectUrl(user.data, environmentProperties);
};

const getuseCapabilities = ({ overview }) => {
	return overview?.userCapabilities;
};

export const getModel = createSelector([
	getUserManager,
	getRedirectUrlSelector,
	getuseCapabilities
], (
	userManager,
	redirectUrl,
	userCapabilities
) => {

	return {
		userManager,
		redirectUrl,
		userCapabilities
	};
});
